export default {
  'resultandsuccess.success.title': '提交成功',
  'resultandsuccess.success.description':
    '提交结果页用于反馈一系列操作任务的处理结果， 如果仅是简单操作，使用 Message 全局提示反馈即可。 本文字区域可以展示简单的补充说明，如果有类似展示 “单据”的需求，下面这个灰色区域可以呈现比较复杂的内容。',
  'resultandsuccess.success.operate-title': '项目名称',
  'resultandsuccess.success.operate-id': '项目 ID',
  'resultandsuccess.success.principal': '负责人',
  'resultandsuccess.success.operate-time': '生效时间',
  'resultandsuccess.success.step1-title': '创建项目',
  'resultandsuccess.success.step1-operator': '曲丽丽',
  'resultandsuccess.success.step2-title': '部门初审',
  'resultandsuccess.success.step2-operator': '周毛毛',
  'resultandsuccess.success.step2-extra': '催一下',
  'resultandsuccess.success.step3-title': '财务复核',
  'resultandsuccess.success.step4-title': '完成',
  'resultandsuccess.success.btn-return': '返回列表',
  'resultandsuccess.success.btn-project': '查看项目',
  'resultandsuccess.success.btn-print': '打印',
};
